import React from 'react';
import { useLocation } from 'react-router-dom';
import { BottomNavigation } from './BottomNavigation';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();

  // Страницы БЕЗ нижней навигации
  const pagesWithoutBottomNav = ['/onboarding', '/sbp-linking', '/claim-reward'];
  const showBottomNav = !pagesWithoutBottomNav.some(path => location.pathname.startsWith(path));

  return (
    <div className="app">
      <div className={`app-content ${showBottomNav ? 'with-nav-only' : ''}`}>
        {children}
      </div>
      {showBottomNav && <BottomNavigation />}
    </div>
  );
};
